// extracted by mini-css-extract-plugin
module.exports = {"icon":"IconBase__icon__WmzWG","spaceRight":"IconBase__spaceRight__4DJN7","spaceLeft":"IconBase__spaceLeft__hQei-"};